export default __webpack_public_path__ + "static/media/intel.9209521f.png";